/** Compact stage chrome only; document/page formatting and editor toolbars stay unchanged. */
export const documentEditorStageSx = {
  p: 0,
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  minWidth: 0,
  '& > [data-document-editor-header]': {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    flexWrap: 'wrap', gap: 1, mb: 0.5,
    '& h4': { fontSize: '1.5rem', lineHeight: 1.25, m: 0, overflowWrap: 'anywhere' },
  },
} as const;

export const documentEditorControlsSx = {
  display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 1, mb: 1,
} as const;

export const documentEditorCenteredControlsSx = {
  display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0, width: '100%',
  '& .MuiFormControlLabel-root': { m: 0, minHeight: 44 },
} as const;

export const documentEditorControlGroupSx = {
  display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 1,
} as const;

/** Opt-in markers cover every alias of the shared editor stages, including read-only views. */
export const documentEditorWrapperSx = {
  '&:has([data-document-editor-stage])': {
    py: 0.5,
    '& > [data-stage-navigation-panel]': { p: 0.5, mb: 0 },
    '& [data-stage-navigation-button]': { minWidth: 112 },
    '& [data-testid="stage-content-paper"]': { p: 1, pt: 0.5 },
  },
} as const;
